/**
 * Invoices imported from a previous system (`legacySource` set, e.g. the
 * Innovoice import) are collected in that system, not in OS Buddy (#4189).
 * The workshop finishes them there, so OS Buddy never shows them as overdue,
 * offers them for payment matching, or reminds about them.
 */

/** Statuses after which nothing is left to collect. */
const SETTLED_STATUSES: ReadonlySet<string> = new Set(['paid', 'void', 'credited', 'refunded']);

interface CollectionFields {
  readonly legacySource?: string | null | undefined;
  readonly status: string;
}

/** True when the invoice is still open but collected outside OS Buddy. */
export function isCollectedExternally(invoice: CollectionFields): boolean {
  return Boolean(invoice.legacySource) && !SETTLED_STATUSES.has(invoice.status);
}

interface OverdueFields extends CollectionFields {
  readonly dueDate: string | null;
}

/**
 * Client-side overdue check for views that do not get the server flag. An
 * invoice collected elsewhere is never overdue here.
 */
export function isInvoiceOverdueHere(invoice: OverdueFields, now: Date = new Date()): boolean {
  if (invoice.legacySource) return false;
  if (!invoice.dueDate) return false;
  return new Date(invoice.dueDate) < now && invoice.status !== 'paid' && invoice.status !== 'void';
}
